import { gql } from 'graphql-request';

export default gql`
  query users(
    $skip: Int
    $take: Int
    $orderBy: JSON
    $filters: JSON
    $mask: String
  ) {
    users(
      skip: $skip
      take: $take
      orderBy: $orderBy
      filters: $filters
      mask: $mask
    ) {
      totalCount
      skip
      take
      users {
        id
        account_id
        doc
        listing
        createdAt
        updatedAt
        hasPhoto
        extra

        Pipes {
          id
          account_id
          key
          type
          metadata
          users
          settings
          updatedAt
          createdAt
        }
      }
    }
  }
`;
